document.addEventListener("DOMContentLoaded", function () {
    const ringSizeButtons = document.querySelectorAll(".show-ring-size");
      const ringSizeJsonUrl = document.querySelector('meta[name="ring-sizes-json"]').content;

  
    if (!ringSizeButtons.length) {
      console.error("No ring size buttons found.");
      return;
    }
  
    fetch(ringSizeJsonUrl)
      .then((response) => response.json())
      .then((ringSizeData) => {
        console.log("Ring size data loaded:", ringSizeData); // Debugging log
  
        // Ensure data is sorted for accurate lookups
        ringSizeData.sort((a, b) => a.diameter_mm - b.diameter_mm);
  
        function findClosestSize(value, key) {
          let closestMatch = ringSizeData[0];
          let smallestDiff = Math.abs(value - closestMatch[key]);
  
          for (let i = 1; i < ringSizeData.length; i++) {
            const currentDiff = Math.abs(value - ringSizeData[i][key]);
  
            if (currentDiff < smallestDiff) {
              closestMatch = ringSizeData[i];
              smallestDiff = currentDiff;
            }
          }
  
          return closestMatch;
        }
  
        function showRingSize(button) {
          const isCircumference = button.dataset.type === "circumference";
          const inputField = isCircumference
            ? document.getElementById("finger-circumference")
            : document.getElementById("ring-diameter");
  
          const displayField = button.nextElementSibling; // The `<p class="ring-size-display">`
  
          if (!inputField || !displayField) {
            console.error("Input field or display field missing for button:", button);
            return;
          }
  
          const inputValue = parseFloat(inputField.value.trim());
          if (isNaN(inputValue)) {
            displayField.textContent = "Enter a valid size in mm.";
            return;
          }
  
          // Error messages based on input ranges
          if (isCircumference) {
            if (inputValue < 37) {
              displayField.textContent = "That seems a little small, check the circumference of your finger again.";
              return;
            }
            if (inputValue > 69) {
              displayField.textContent = "Our ring sizes only go up to a size Z (68mm) - check your finger circumference again.";
              return;
            }
          } else {
            if (inputValue < 11.5) {
              displayField.textContent = "That seems a little small, check the diameter of your ring again.";
              return;
            }
            if (inputValue > 22) {
              displayField.textContent = "Our ring sizes only go up to a size Z (22mm diameter) - check your ring diameter again.";
              return;
            }
          }
  
          const key = isCircumference ? "circumference_mm" : "diameter_mm";
          const closestSize = findClosestSize(inputValue, key);
  
          displayField.textContent = `You are a UK ring size: ${closestSize.UK}`;
        }
  
        ringSizeButtons.forEach((button) => {
          button.addEventListener("click", () => showRingSize(button));
        });
      })
      .catch((error) => console.error("Error loading ring size data:", error));
  });